export const truncateWallet = (wallet) => {
  if (!wallet || wallet.length < 10) return wallet;
  return `${wallet.slice(0, 5)}...${wallet.slice(-4)}`;
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString('en-US', { month: 'short' });
  const year = date.getFullYear().toString().slice(-2);
  return `${day} ${month}, ${year}`;
};
